import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/bootstrap.min.css';
import './assets/css/style.css';
// Font Awesome is loaded via index.css or should be loaded asynchronously
// to avoid render-blocking. If using local FA, keep this import.
// If using CDN, remove this import and add a <link> with media="print" onload trick.
import './assets/fontIcon/css/all.min.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Measure and report Core Web Vitals
reportWebVitals();
